import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Centralised branches loader. Most screens only need the active list and a
 * lookup table by id (e.g., to render "Stock Yard" instead of a raw uuid).
 */
export default function useBranches({ activeOnly = false, kind = "", includeAll = false } = {}) {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (activeOnly) params.active_only = true;
      if (kind) params.kind = kind;
      if (includeAll) params.include_all = true;
      const { data } = await api.get("/branches", { params });
      setBranches(data || []);
    } finally {
      setLoading(false);
    }
  }, [activeOnly, kind, includeAll]);

  useEffect(() => {
    reload();
  }, [reload]);

  const byId = branches.reduce((acc, b) => {
    acc[b.id] = b;
    return acc;
  }, {});

  return { branches, byId, loading, reload };
}
